/**
 * Variables for some entities creation by corresponding template entities:
 *   - Creation of BRS tasks by BRS task templates;
 *   - Creation of manual documents by manual document templates;
 *
 * These variables using as placeholders in template entities fields.
 * On entity creation these placeholders will be replaced by real values.
 */
export enum TemplateEntityVariableEnum {
  CONTRAGENT = 'Контрагент',
  AMOUNT_OF_DEBTS = 'СуммаДолгов',
  RECIPIENTS_NAME = 'ИмяПолучателя',
  COMPANY = 'Компания',
  DATE = 'Дата',
  CURRENT_MONTH = 'ТекущийМесяц',
  PREVIOUS_MONTH = 'ПредыдущийМесяц',
  NEXT_MONTH = 'СледующийМесяц',
  CURRENT_MONTH_NUMERIC = 'ТекущийМесяцЧисло',
  PREVIOUS_MONTH_NUMERIC = 'ПредыдущийМесяцЧисло',
  NEXT_MONTH_NUMERIC = 'СледующийМесяцЧисло',
  CURRENT_QUARTER = 'ТекущийКвартал',
  PREVIOUS_QUARTER = 'ПредыдущийКвартал',
  NEXT_QUARTER = 'СледующийКвартал',
  CURRENT_YEAR = 'ТекущийГод',
  PREVIOUS_YEAR = 'ПредыдущийГод',
  NEXT_YEAR = 'СледующийГод',
  TELEGRAM_PRIVATE_LINK = 'ПриглашениеTelegram',
}
